import type { CurationCellStatus, ExtractionCell, ExtractionRow } from "./types";

const cellHasStatus = (cell: ExtractionCell, status: CurationCellStatus) => {
  if (status === "matched") {
    return cell.verification_status === "explained" && cell.record_match != null;
  }
  if (status === "explained") {
    return cell.verification_status === "explained" && cell.record_match == null;
  }
  return cell.verification_status === status;
};

/**
 * The rows that the grid filters keep, by the rules of the server's grid inspect:
 * a status keeps a row of that status or with a cell of it, and with a column only a
 * cell of that column counts. A column alone keeps every row; the grid shows only it.
 */
export const filterGridRows = (
  rows: ExtractionRow[],
  status: CurationCellStatus | "",
  columnId: string,
): ExtractionRow[] => {
  if (!status) return rows;
  return rows.filter((row) => {
    if (columnId) {
      return row.cells.some(
        (cell) => cell.column_id === columnId && cellHasStatus(cell, status),
      );
    }
    if (status === "matched") return row.cells.some((cell) => cellHasStatus(cell, status));
    return row.status === status || row.cells.some((cell) => cellHasStatus(cell, status));
  });
};
